import {cloneDeep, get} from "lodash";
import {getBoolean, getString} from 'Core/helpers/data';
import {ExternalQuestionnairesItemQuestionnairesListDataObject} from "../dataObjects";
import {getDate, STANDARD_DATE_TIME_FORMAT} from "Core/helpers/datetime";

/**
 * Get input data from raw data
 * @param {Object} rawData - Raw data received from IO.
 * @return {ExternalQuestionnairesItemQuestionnairesListDataObject}
 */
export const input = rawData => {
	let result = cloneDeep(rawData);

	result = new ExternalQuestionnairesItemQuestionnairesListDataObject(
		getString(result, 'id'),
		getString(result, 'firstName'),
		getString(result, 'lastName'),
		getDate(get(result, 'dateOfBirth', null), STANDARD_DATE_TIME_FORMAT.ISO_DATE_TIME_S),
		getDate(get(result, 'dateQuestionnaireSubmitted', null), STANDARD_DATE_TIME_FORMAT.ISO_DATE_TIME_S),
		(result?.studyRefNo ? getString(result, 'studyRefNo') : undefined),
		getBoolean(result, 'deleted')
	);

	return result;
}

// @note: There is no output function since list is read-only.